// extracted by mini-css-extract-plugin
export default {"videos_container":"VideoPage_videos_container__LnU7O"};